import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import ScrollToTop from "./ScrollToTop";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </>
  );
};

export default Layout;
